import { InputProps } from '@/components/form/Input';
import { cn } from '@/utils/classname';

export interface DateProps {
  min?: string;
  max?: string;
}

export const Date = (props: InputProps) => {
  return (
    <input
      type="date"
      name={props.name}
      id={props.name}
      className={cn(
        'bg-chariot-background-secondary border-chariot-stroke text-chariot-text-primary',
        'placeholder-chariot-text-tertiary w-full rounded-md border px-3 py-2 text-sm',
        'focus:border-chariot-brand-primary transition-colors focus:outline-hidden',
        'disabled:bg-chariot-background-tertiary disabled:cursor-not-allowed disabled:opacity-50',
        'cursor-pointer',
        props.className
      )}
      onChange={props.onChange}
      value={props.value || ''}
      min={props.min}
      max={props.max}
      disabled={props.disabled}
      required={props.required}
      placeholder={props.placeholder}
      onClick={e => {
        // This makes the entire field clickable to open the date picker
        const input = e.target as HTMLInputElement;
        input.showPicker?.();
      }}
    />
  );
};
